import request from './plugins/request'

// 新建一条
export let createExpert = (params = {}) => {
    return request({
        url: '/expert',
        params: params,
        method: 'post'
    })
}

// 获取列表
export let getExpertList = (params = {}) => {
    return request({
        url: '/expert',
        params: params
    })
}


//获取某一条的详情
export let getExpertDetails = (params) => {
    return request({
        url: '/expert/'+params
    })
}

//删除某一条
export let deleteExpert = (params) => {
    return request({
        url: '/expert/'+params,
        method: 'delete'
    })
}

//修改某一条
export let putExpert = (params,id) => {
    return request({
        url: '/expert/'+id,
        method: 'put',
        params: params
    })
}

